import { Mappable, Mapped } from '../../rest/decorators/mapped'

@Mapped({})
export class JobAccountingStatus extends Mappable {
  id!: string
  title!: string
  colour!: string

  static create<Data>(attrs: Data) {
    return new JobAccountingStatus().map(attrs)
  }
}
